export const getManualSlottingAvailability = ({ autoSlotState, settingsStatus, selectedDate }) => {
  if (settingsStatus === 'loading') {
    return { message: 'Checking slotting settings. . .', showAllDates: false, showSelectedDate: false };
  }

  if (settingsStatus !== 'ready') {
    return {
      message: 'Manual slotting is unavailable because slotting settings could not be verified.',
      showAllDates: false,
      showSelectedDate: false,
    };
  }

  if (autoSlotState) {
    return {
      message: 'Automatic registration runs in batches, normally every five minutes.',
      showAllDates: false,
      showSelectedDate: false,
    };
  }

  return {
    message: null,
    showAllDates: true,
    showSelectedDate: Boolean(selectedDate?.pk_InterviewDate),
  };
};
